import { ParameterQuery } from "utils/commonFunctions";

interface CosmeticGradingEndpoint {
    baseUrl: string;
    apiKey: string;
}

const DEV_COSMETIC_GRADING_ENDPOINT: CosmeticGradingEndpoint = {
    baseUrl: "https://dev-cosmeticgrading.mobilesolutions.ai/",
    apiKey: "7cfb7519-dc14-436c-8881-20be8da0d68a",
};

const COSMETIC_GRADING_ENDPOINT_BY_STAGE: Record<string, CosmeticGradingEndpoint> = {
    dev: DEV_COSMETIC_GRADING_ENDPOINT,
    demo: {
        baseUrl: "https://demo-cosmeticgrading.mobilesolutions.ai/",
        apiKey: "7cfb7519-dc14-436c-8881-20be8da0d68a",
    },
    staging: {
        baseUrl: "https://staging-cosmeticgrading.mobilesolutions.ai/",
        apiKey: "7cfb7519-dc14-436c-8881-20be8da0d68a",
    },
    prod: {
        baseUrl: "https://cosmeticgrading.mobilesolutions.ai/",
        apiKey: "b652-6bff-fb60-51ba",
    },
};

const MOBILE_USER_AGENT_PATTERN = /Android|iPhone|iPad|iPod|Mobile/i;
const IPADOS_DESKTOP_USER_AGENT_PATTERN = /Macintosh/i;
const MIN_TOUCH_POINTS_FOR_TOUCH_SCREEN = 2;

const CURRENT_STAGE = process.env.STAGE ?? "dev";
const COSMETIC_GRADING_ENDPOINT = COSMETIC_GRADING_ENDPOINT_BY_STAGE[CURRENT_STAGE] ?? DEV_COSMETIC_GRADING_ENDPOINT;

export function buildCosmeticGradingUrl(tenantUuid: string): string {
    const queryString = new ParameterQuery()
        .add("key", COSMETIC_GRADING_ENDPOINT.apiKey)
        .add("tenant_uuid", tenantUuid)
        .createQueryString();
    return COSMETIC_GRADING_ENDPOINT.baseUrl + queryString;
}

export function isMobileDevice(
    userAgent: string = navigator.userAgent,
    maxTouchPoints: number = navigator.maxTouchPoints
) {
    if (MOBILE_USER_AGENT_PATTERN.test(userAgent)) {
        return true;
    }
    // iPadOS 13+ Safari sends a desktop Macintosh user agent, so tell iPads from Macs by touch support. The check is
    // limited to Macintosh because Windows and Linux touch laptops must still count as laptops.
    return IPADOS_DESKTOP_USER_AGENT_PATTERN.test(userAgent) && maxTouchPoints >= MIN_TOUCH_POINTS_FOR_TOUCH_SCREEN;
}
